export enum ReportActionType {
  RenameReport = 'RenameReport',

  LoadEmbeddedReport = 'LoadEmbeddedReport',
  UpdateEmbeddedReport = 'UpdateEmbeddedReport',

  LoadThemeSuccess = 'LoadThemeSuccess',

  UpdateReport = 'UpdateReport',
  UpdateReportSuccess = 'UpdateReportSuccess',
  UpdateReportFailure = 'UpdateReportFailure',
  ReportLayoutTextChanged = 'ReportLayoutTextChanged',

  UpdateSelectedReportSpace = 'UpdateSelectedReportSpace',
  UpdateSelectedReportSpaceSuccess = 'UpdateSelectedReportSpaceSuccess',
  UpdateSelectedReportSpaceFailure = 'UpdateSelectedReportSpaceFailure',

  UpdateSelectedReportLastSavedAt = 'UpdateSelectedReportLastSavedAt',
  UpdateIfReportNeedsUpdate = 'UpdateIfReportNeedsUpdate',

  SaveReportCharts = 'SaveReportCharts',
  SaveReportChartsSuccess = 'SaveReportChartsSuccess',
  SaveReportChartsFailure = 'SaveReportChartsFailure',
  SaveSingleReportChartSuccess = 'SaveSingleReportChartSuccess',
  SaveSingleReportChartFailure = 'SaveSingleReportChartFailure',

  SaveReportTables = 'SaveReportTables',
  SaveReportTablesSuccess = 'SaveReportTablesSuccess',
  SaveReportTablesFailure = 'SaveReportTablesFailure',
  SaveSingleReportTableSuccess = 'SaveSingleReportTableSuccess',
  SaveSingleReportTableFailure = 'SaveSingleReportTableFailure',

  SetSelectedReportEmbedded = 'SetSelectedReportEmbedded',
  SetSelectedReportEmbeddedSuccess = 'SetSelectedReportEmbeddedSuccess',
  SetSelectedReportEmbeddedFailure = 'SetSelectedReportEmbeddedFailure',

  SetSelectedReportShared = 'SetSelectedReportShared',
  SetSelectedReportSharedSuccess = 'SetSelectedReportSharedSuccess',
  SetSelectedReportSharedFailure = 'SetSelectedReportSharedFailure',

  ToggleReportUserStar = 'ToggleReportUserStar',
  ToggleReportUserStarSuccess = 'ToggleReportUserStarSuccess',
  ToggleReportUserStarFailure = 'ToggleReportUserStarFailure',

  // new report run or failed report run banner related actions
  UpdateRecentReport = 'UpdateRecentReport',
  UpdateRecentReportDetails = 'UpdateRecentReportDetails',

  // Report view details page related actions
  InitQueryResultPagination = 'InitQueryResultPagination',

  UpdateReportSettings = 'UpdateReportSettings',

  SetReportCaptureMode = 'SetReportCaptureMode',
  SetReportCaptureRunCreatedTime = 'SetReportCaptureRunCreatedTime',

  // Same action is defined in dataset.actions.ts
  PublishDatasetAfterMoveSpace = 'PublishDataset After MoveSpace',
}
